// extracted by mini-css-extract-plugin
module.exports = {"root":"Chip_root__2aGJ4","selected":"Chip_selected__3so0N"};